/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import {
  Space,
  Tag,
} from 'antd';
import Button from 'antd-button-color';
import 'antd-button-color/dist/css/style.css';
import moment from 'moment/moment';
import Can from '../../util/can';
import { DATA_TRAFFIC_WEBSITES } from '../../constants/resources';

export const TrafficWebsitesColumns = (
  handleEdit,
  handleEditRecord,
  timezone,
) => {

  const offset = timezone?.offset ?? 3;

  return [
    {
      title: 'Domain',
      dataIndex: 'name',
      width: 160,
      sorter: true,
    },
    {
      title: 'IP',
      dataIndex: 'ip',
      width: 80,
      sorter: false,
      search: false,
    },
    {
      title: 'URL Level',
      dataIndex: 'url',
      width: 200,
      sorter: false,
      search: false,
    },
    {
      title: 'Black Listed',
      dataIndex: 'black_listed',
      width: 60,
      sorter: false,
      search: false,
      render: (val, record) => (
        <>
          <div>
            <Tag color={record.black_listed ? 'green' : 'red'}>
              {record.black_listed ? 'Yes' : 'No'}
            </Tag>
          </div>
        </>
      ),
    },
    {
      title: 'Created Date',
      dataIndex: 'created_at',
      width: 120,
      sorter: false,
      search: false,
      render: (date) => (
        <span title={date}>
          {moment(date).utc().add('hours', offset).format('DD/MM/YYYY h:mm:ss a')}
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      search: false,
      render: (record) => (
        <Space size="middle">
          <Can I="update" a={DATA_TRAFFIC_WEBSITES}>
            <Button
              data-testid={`update-record-${record._id}`}
              type="primary"
              className="ant-btn-sm ant-btn-background-ghost"
              onClick={() => {
                handleEdit(record);
                handleEditRecord(record);
              }}
            >
              <i className="icon icon-edit" />
            </Button>
          </Can>
        </Space>
      ),
    },
  ];
}
